// @ts-check
// =============================================================================
// main.js — THE ENTRY POINT of the new Deckbiter client.
//
// esbuild starts here and follows the import graph to bundle the whole app
// (our modules + the shared rules from /src/rules/ + the npm libraries) into
// the single public/client.<hash>.js the browser loads.
//
// Keep this file trivial: everything real lives in js/app/boot.js.
// =============================================================================

import { startApp } from './js/app/boot.js';

// The bundle is loaded with <script defer>, so the DOM is parsed by the time
// this runs — boot immediately.
startApp();
